import { j as r } from "./AccesRecoveryIcon-CUPieIxT.js";
const o = () => /* @__PURE__ */ r.jsxs("svg", { viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ r.jsxs("g", { stroke: "currentColor", clipPath: "url(#a)", children: [
    /* @__PURE__ */ r.jsx("path", { d: "M5 9.167A4.167 4.167 0 1 0 5 .834a4.167 4.167 0 0 0 0 8.333Z" }),
    /* @__PURE__ */ r.jsx("path", { d: "M5 2.918h.004", strokeLinecap: "round" }),
    /* @__PURE__ */ r.jsx("path", { d: "M4.166 4.584h.833v2.083m-.833.001h1.667", strokeLinecap: "round", strokeLinejoin: "round" })
  ] }),
  /* @__PURE__ */ r.jsx("defs", { children: /* @__PURE__ */ r.jsx("clipPath", { id: "a", children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M0 0h10v10H0z" }) }) })
] });
export {
  o as I
};
